// 
import Uri from 'urijs';
import { sortObject } from './object';

// sort parameters in Uri
export const normalizeUrl = (url) => {
  const uri = Uri(url);
  const uriQuery = uri.query();
  uri.query('');
  const newQuery = sortObject(Uri.parseQuery(uriQuery));
  uri.query(newQuery);
  return uri.toString();
};

export const getOrigin = () => {
  return window.location.origin ? window.location.origin : window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
};

export const isRoutingAnchor = (anchor) => {
  // Ignore anchor with target.
  const targetAttribute = anchor.getAttribute('target');
  if (targetAttribute && targetAttribute !== '') {
    return false;
  }
  // ignore tree nodes
  if (anchor.classList.contains('treeRowHref')) {
    return false;
  }

  if (anchor.closest('.noPartialUpdate') != null) {
    return false;
  }

  if (anchor.getAttribute('data-pu') != null || anchor.getAttribute('data-partial-update') != null) {
    return false;
  }

  const href = anchor.getAttribute('href').replace(getOrigin(), '');

  // Ignore hrefs start with hash
  if (href.startsWith('filebrowser?')) {
    return false;
  }
  if (href.lastIndexOf('#', 0) === 0) {
    return false;
  }
  // Ignore hrefs start with javascript:
  if (href.lastIndexOf('javascript:', 0) === 0) {
    return false;
  }
  // ignore http and https
  if (href.lastIndexOf('http', 0) === 0 || href.lastIndexOf('https', 0) === 0) {
    return false;
  }
  // Ignore mailto
  if (href.lastIndexOf('mailto:', 0) === 0) {
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./node_modules/@fg/fg-frontend/src/lib/urlAndLink.js